export type RepairCostingFilterType = {
  equipmentId?: string;
  damageName?: string;
  damageSeverity?: string;
  repairServiceId?: string;
  status?: string;
};

export enum RepairCostingLocalStorage {
  EQUIPMENT_ID = 'repairCostingFilterEquipmentId',
  DAMAGE_NAME = 'repairCostingFilterDamageName',
  DAMAGE_SEVERITY = 'repairCostingFilterDamageSeverity',
  REPAIR_SERVICE_ID = 'repairCostingFilterRepairServiceId',
  STATUS = 'repairCostingFilterStatus',
}
